import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/aquaart-group/src/components/entities/header/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/components/ui/container/index.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/aquaart-group/src/views/success-story/[slug]/components/content/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/aquaart-group/src/views/success-story/[slug]/components/header/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/views/success-story/[slug]/index.module.scss");
